import ProcessFlowStep from "~/models/processFlows/processFlowStep"
import { ProcessFlowStepType } from "../../../enums/processFlowStepType"
import ProcessFlow from "~/models/processFlows/processFlow"
import { CertificateInputMap } from '~/models/processFlows/steps/certificateInputMap'
import { ObjectHelper } from '~/helpers/objectHelper'
import {ICertificateInputMap, IGenerateDocumentStep, IProcessFlowVariable} from '~/interfaces/processFlowInterfaces'
import { IHasParent, ITrackedModel } from '~/interfaces/modelInterfaces'
import IterationStep from "~/models/processFlows/steps/iterationStep";
import ProcessFlowVariable from '~/models/processFlows/processFlowVariable'
import ProcessFlowMappedVariable from "~/models/processFlows/steps/processFlowMappedVariable";
import {ProcessFlowMappedVariableType} from "../../../../formability/processFlowBuilder/enums/processFlowMappedVariableType";

interface ICertificateDynamicInput {
  client_id: string,
  id: string,
  is_list: boolean,
  name: string,
  sort_order: number,
  type: number
}

interface TempCertDoc {
  certificate_dynamic_inputs: Array<ICertificateDynamicInput>
  id: null
  title: null
}

/**
 * @deprecated use {GenerateDocumentV2Step} instead
 */
export class GenerateDocumentStep extends ProcessFlowStep implements IGenerateDocumentStep {
  step_type: ProcessFlowStepType.GenerateDocument
  certificate_id: string
  certificate_input_maps: { [key: string]: CertificateInputMap } = {}
  get certificateInputMapsArray(): CertificateInputMap[] {
    return ObjectHelper.toArray(this.certificate_input_maps);
  }
  // a helper for the UI
  _document: TempCertDoc
  get document(): TempCertDoc {
    return this._document
  }

  set document(val: TempCertDoc) {
    this._document = val
  }
  destination_variable_client_id: string

  // file_name: ProcessFlowMappedVariable

  constructor(parent: ProcessFlow | IterationStep, options?) {
    super(parent, options)
    this.defineProperty<this>('certificate_id', null)
    this.defineProperty<this>('destination_variable_client_id', null)
    if (options.firstCreation) {
      // do not setup defaults when loading json from backend
      this.initDefaults();
    }
  }

  // ******************** RELATIONS AND REPOS ******************** //

  initializeEmbedded(parent: IGenerateDocumentStep & ITrackedModel, item: ICertificateInputMap & IHasParent<IGenerateDocumentStep>, position: number = null, json: object = {}, selectItem: boolean = true) {
    item.triggerChanges = true
    item.parent = parent
    item.startTracking()
    this.placeInDictionary(item, item.rootName, this)
    parent.trackCreationDeletion(item.client_id, null, item.asJson(), item)
    return item
  }
  // ******************** RELATIONS AND REPOS END ******************** //

  initDefaults() {
    const formulaFileName = new ProcessFlowMappedVariable('file_name', {}, {source_type: ProcessFlowMappedVariableType.Formula});
    formulaFileName.attachToParent(this)
  }

  /**
   * Remove any ReferencePaths that are not referenced something (like a formula)
   */
  cleanUpPaths(): void {
    for (const inputMap of this.certificateInputMapsArray) {
      inputMap.cleanUpPaths()
    }
  }

  /**
   * Clean up the input mappings since they no longer make sense for a different certificate
   * @param certId
   */
  setCertificateId(certId: string): void {
    if (this.certificate_id === certId) return;

    this.certificate_id = certId
    this.certificateInputMapsArray.forEach(map => map.destroy())
  }

  /**
   * For common process flow step interface
   */
  get destinationVariable(): IProcessFlowVariable {
    return this.outputVariable
  }

  get destinationVariableClientId(): string {
    return this.destination_variable_client_id
  }

  set destinationVariableClientId(val: string) {
    this.destination_variable_client_id = val
  }
  //*****

  get defaultTitle(): string {
    return `Generate ${this.document?.title || ""} Document`
  }

  /**
   * The variable to output the document to
   * @private
   */
  private get outputVariable(): IProcessFlowVariable {
    return ProcessFlowVariable.repo.find(this.destinationVariableClientId)
  }
}